import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, FlexControlledForm, useResponsive } from '@common-fe/common-fe';

import { SnackbarState } from '@/modules/core/core.types';
import { useSnackbar } from '@/modules/core/hooks';
import { EmployeeAddress } from '@/modules/user/user.types';

import { useEditEmployeeAddressFields, useEmployeeAddressSave } from './hooks';

interface Props {
  address: EmployeeAddress;
  onClose: () => void;
  onSuccess?: () => void;
  withoutSnackbar?: boolean;
}
const EditEmployeeAddressForm: React.FC<Props> = ({ address, onClose, onSuccess, withoutSnackbar }) => {
  const { isMobile } = useResponsive();
  const fields = useEditEmployeeAddressFields({
    address,
  });
  const { handleAddPermanentSnackbar } = useSnackbar();

  const { setState, handleSave, isSubmitted } = useEmployeeAddressSave({
    fields,
    onSuccess: () => {
      (onSuccess || onClose)();
      if (!withoutSnackbar) {
        handleAddPermanentSnackbar({
          text: t('Your address has been changed.'),
          state: SnackbarState.positive,
          closeIcon: true,
          autoRemove: true,
        });
      }
    },
  });
  const { t } = useTranslation();
  return (
    <Box data-testId="edit-employee-address_form">
      <Box pad={isMobile ? 'spacing8' : 'spacing24'} round="moduleRound" background="module">
        <Box background="canvas" round="container1Round">
          <FlexControlledForm
            testId="edit-address"
            fields={fields}
            isModalType
            showError={isSubmitted}
            editMode
            onChangeValues={(values) => {
              setState(values);
            }}
          />
        </Box>
      </Box>
      <Box
        margin={isMobile ? { top: 'spacing16' } : { top: 'spacing24' }}
        direction={isMobile ? 'column-reverse' : 'row'}
        justify="end"
        gap="spacing12"
      >
        <AppButton
          testId="cancel-edit-employee"
          onClick={onClose}
          buttonType="secondary"
          width={isMobile ? '100%' : '180px'}
        >
          {t('Cancel')}
        </AppButton>

        <AppButton testId="save-edit-employee" onClick={handleSave} width={isMobile ? '100%' : '180px'}>
          {t('Save')}
        </AppButton>
      </Box>
    </Box>
  );
};

export default EditEmployeeAddressForm;
